import { render, staticRenderFns } from "./TcLoginPublic.vue?vue&type=template&id=0628d3c3&"
import script from "./TcLoginPublic.vue?vue&type=script&lang=js&"
export * from "./TcLoginPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0628d3c3')) {
      api.createRecord('0628d3c3', component.options)
    } else {
      api.reload('0628d3c3', component.options)
    }
    module.hot.accept("./TcLoginPublic.vue?vue&type=template&id=0628d3c3&", function () {
      api.rerender('0628d3c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcLoginPublic.vue"
export default component.exports